import { useScope } from "~/hooks/useScope";
import { PlatformPoliciesAddQueryDetailPage } from "~/pages/platform/policies-add/PlatformPoliciesAddQueryDetailPage";

export function PlatformPoliciesAddQueryDetailEntryPage() {
  const { regionScope } = useScope();
  return regionScope ? (
    <PlatformPoliciesAddQueryDetailPage scope={regionScope} />
  ) : undefined;
}
